module.exports = __webpack_public_path__ + "static/media/varme.237bbad8.m4a";